/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import customFunction from "../../../../customFunction/customFunction";
import Pagination from "../../../Pagination/Pagination";
import { ACCESSORY_IMAGES_PREFIX } from "../../../../_constants/accessoryfinder.constants";

const AccessoriesResult = (props) => {
  const pageSize = props.pageSize;
  const [indexOfLast, setIndexOfLast] = useState([1 * pageSize]);
  const [indexOfFirst, setIndexOfFirst] = useState([1 * pageSize - pageSize]);

  function handleChildClick(currentPage) {
    setIndexOfLast(currentPage * pageSize);
    setIndexOfFirst(currentPage * pageSize - pageSize);
    customFunction.goTo("#searchResult");
  }
  useEffect(() => {
    setIndexOfLast(1 * pageSize);
    setIndexOfFirst(1 * pageSize - pageSize);
  }, []);
  let dataBind = props.data.slice(indexOfFirst, indexOfLast);
  return (
    <React.Fragment>
      {dataBind.length &&
        dataBind.map((model) => (
          <div className="row" key={model.accessoryModelID}>
            <div className="col-sm-12 col-md-12">
              <div className="card cardNew">
                <div className="card-body">
                  <div className="row ">
                    <div className="col-md-3">
                      <img
                        src={
                          ACCESSORY_IMAGES_PREFIX +
                          "/AccessoryImages/" +
                          model.image
                        }
                        style={{ height: "220px" }}
                        alt={model.accessoryName}
                        className="img-fluid"
                      />
                    </div>
                    <div className="col-md-9">
                      <h5>
                        <p>Model #{model.accessoryModelID}</p>
                        <p>{model.accessoryName}</p>
                      </h5>
                      <span
                        dangerouslySetInnerHTML={{ __html: model.description }}
                      ></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      <Pagination
        totalRecords={props.data.length}
        pageSize={pageSize}
        onChildClick={handleChildClick}
      />
    </React.Fragment>
  );
};
export default AccessoriesResult;
